import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import Button from '@material-ui/core/Button';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import {Helmet} from 'react-helmet'



import styles from "assets/jss/material-kit-react/views/spaghetti.js";
import { string } from "prop-types";

const useStyles = makeStyles(styles);

export default function PentestMainPage(props) {
    const classes = useStyles();

    const { ...rest } = props;
    const imageClasses = classNames(
        classes.imgRaised,
        classes.imgRoundedCircle,
        classes.imgFluid
    );

    return (
        <div>
            <Header
                color="transparent"
                brand="Material Kit React"
                rightLinks={<HeaderLinks />}
                fixed
                changeColorOnScroll={{
                    height: 200,
                    color: "white"
                }}
                {...rest}
            />
            <Helmet>
    <title>کمپ آموزشی شریف | تست های امنیت</title>
    <meta name="description" content="کمپ آموزشی شریف (sharifcamp) خدمات مربوط به تست نفوذ و سایر تست ها و مشاوره های امنیتی را با تکیه بر کادر متخصص خود ارائه مینماید." />
 <meta name="" content="PenetrationTesting, PenTest, تست امنیت, امنیت سیستم, Events,Mobile,Programming,TopDev,Scrum,Agile,Course,Exhabitions,کمپ آموزشی, بوت کمپ, کدنویسی مبهم"/>
  </Helmet>
            <Parallax small filter image={require("assets/img/bg18.jpg")} />
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div>
                    <div className={classes.container}>

                        <GridContainer justify="center" className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.topdev}>
                                    <div>
                                        <img src={"https://sharifcamp.ir/assets/images/pentest.jpg"} alt="..." className={imageClasses} />
                                    </div>
                                    <div className={classes.name}>
                                        <h3 className={classes.title}>تست نفوذپذیری</h3>
                                        <div className={classes.description}>
                                            <p>
                                                برای شرکت‌ها، مواجهه با آسیب‌پذیری‌های امنیتی IT در سیستم‌های شبکه‌ شرکت‌ها و سیستم‌های فن‌آوری اطلاعات رایج شده‌است. این آسیب‌پذیری‌های امنیتی IT ممکن است به دلایل بیشماری وجود داشته باشد و از نظر تیم امنیت IT دور مانده باشد.
                                            </p>
                                            <p>
                                                شبکه‌های سازمانی میزان زیادی اطلاعات محرمانه و خصوصی کسب‌و‌کار را ذخیره می‌کنند و با این کار، به اهداف بزرگ برای مجرمان اینترنتی در سراسر جهان تبدیل می‌شوند. مجرمان اینترنتی اشکال مختلفی از حملات مخرب را برای هک کردن، سازگاری یا سرقت اطلاعات مهمی که در شبکه سازمانی ذخیره شده، اعمال می‌کنند.
                                            </p>
                                            <p>
                                                کمپ آموزشی شریف (sharifcamp) خدمات مربوط به تست نفوذ و سایر تست ها و مشاوره های امنیتی را با تکیه بر کادر متخصص خود ارائه مینماید. جهت دریافت مشاوره با ما تماس بگیرید.
                                            </p>
                                        </div>
                                        <div>
                                            <p>
                                                <br />
                                            <Button variant="outlined" href="/ContactUs" disableElevation>
                                                جهت دریافت راهنمایی و مشاوره، با متخصصان ما تماس بگیرید.
                                            </Button>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h3>انواع ارزیابی امنیتی</h3>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>
                                        <strong>ارزیابی امنیتی خارجی</strong>
                                        <br />
                                        در این روش از یک سیستم کامپیوتری از راه دور برای شناسایی آسیب پذیری‌های موجود استفاده می‌شود. در حین تست خارجی، پیکریندی سازمان مقصد به صورت معمول خود است در حالی که گروه تست نفوذ از طریق اینترنت در آزمایشگاه مربوطه برای نفوذ به داخل شبکه، تلاش می‌کنند. ارزیابی معمولاً شامل پویش‌های خارجی برای شناسایی آسیب‌پذیری‌ها و اتصالات کامپیوتری و نیز تلاش برای نفوذ به این سیستم‌ها است.
                                    </p>
                                    <p>
                                        <strong>ارزیابی امنیتی داخلی</strong>
                                        <br />
                                        ارزیابی امنیتی داخلی از نرم افزارهای خودکار مانند ابزارهای پویش برای شناسایی آسیب‌پذیری‌ها در ساختار اطلاعاتی (IS) سیستم هدف استفاده می‌کند. پویش شبکه برای شناسایی سیستم‌ها و وسیله‌های غیرمجاز در شبکه هدف استفاده می‌شود. پویشگرهای مبتنی بر میزبان ممکن است بر روی سرورهایی که دارای فایل‌ها، پوشه‌ها و دستیابی‌های از راه دور و پایگاه داده‌های حساس هستند، اجرا شوند. برای بررسی نتایج پویش، گروه تست نفوذ حق دستیابی به منابع در شبکه داخلی را دارند.
                                    </p>
                                </div>
                            </GridItem>
                        </GridContainer>

                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h3>روش‌های ارزیابی امنیتی</h3>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>
                                        <strong>White Box</strong>
                                        <br />
                                        در این حالت تیم تست نفوذ با اطلاعات کامل درباره موضوع مورد تست، به منابع داخلی شبکه نیز دسترسی دارد. معمولا از این نوع تست برای ارزیابی آسیب‌پذیری‌های داخل شبکه استفاده می‌شود.
                                    </p>
                                    <p>
                                        <strong>Gray Box</strong>
                                        <br />
                                        در این حالت دسترسی به منابع داخلی محدود بوده و اطلاعات کاملی در اختیار تیم تست نفوذ قرار نمی‌گیرد.
                                    </p>
                                    <p>
                                        <strong>Black Box</strong>
                                        <br />
                                        در این حالت هیچ گونه دسترسی و اطلاعاتی به تیم تست نفوذ داده نمی شود. معمولا این نوع پن تست برای وب‌سرورها و برنامه‌های کاربردی تحت وب انجام می‌شود.
                                    </p>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h3>ویژگی‌ها</h3>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>
                                        شناسایی نقاط ضعف در وضعیت امنیت سازمان، اندازه‌گیری انطباق سیاست‌های امنیتی آن، آزمایش آگاهی امنیتی کارکنان و آمادگی رویارویی آنها با موارد امنیتی بررسی می‌شود.
                                    </p>
                                    <p>
                                        یک تست نفوذ همچنین می تواند نقاط ضعف در سیاست‌های امنیتی یک شرکت را مشخص سازد. به عنوان مثال ، ممکن است سیاست امنیتی برای جلوگیری و کشف حمله وجود داشته باشد اما این راهکار برای دور نگه داشتن هکر کافی نباشد. در تست نفوذ این موارد نیز مورد بررسی قرار می‌گیرد.
                                    </p>
                                    <p>
                                        گزارش‌های تولید شده توسط یک تست نفوذ، بازخورد مورد نیاز یک سازمان را برای اولویت‌بندی سرمایه‌گذاری‌های امنیتی فراهم می‌کند. این گزارش‌ها همچنین می‌توانند به توسعه‌دهندگان برنامه‌ها کمک کنند تا برنامه‌های ایمن‌تری ایجاد کنند. اگر توسعه‌دهندگان نحوه نفوذ هکرها به برنامه‌های تولیدی خود را بدانند، امکان اقدام جهت اصلاح و وصله‌کردن و همچنین در تولید برنامه‌های بعد، بستن راه‌های نفوذ فراهم می‌شود.
                                    </p>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h3>مزایای تست نفوذ برای سازمان‌ها</h3>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>
                                        <ul>
                                            <li>
                                                ایمن‌ماندن از حملات هکری که به صورت روز افزون در حال توسعه است.
                                            </li>
                                            <li>
                                                جلوگیری از مختل‌شدن ارائه‌ی سرویس در اثر حملات هکری و یا نقص‌های پیکربندی.
                                            </li>
                                            <li>
                                                شناسایی پیکربندی‌های ضعیف یا عدم پیکربندی‌ها که می‌تواند منجر به سواستفاده شود
                                            </li>
                                            <li>
                                                آموزش و شناخت کارمندان نسبت به ابعاد امنیت و نقش آنها در حفظ محرمانگی اطلاعات سازمان‌ها، جلوگیری از مهندسی اجتماعی و گول خوردن توسط هکرها
                                            </li>
                                            <li>
                                                شناسایی و بررسی منابع سازمان‌ها و اهمیت آنها در تبادل اطلاعات در صورت مختل شدن و یا سرقت آن‌ها بصورت فیزیکی
                                            </li>
                                            <li>
                                                مشخص شدن اهمیت بروزرسانی تجهیزات و دانش اعضا
                                            </li>
                                        </ul>
                                    </p>
                                </div>
                            </GridItem>
                        </GridContainer>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
